import React from 'react';
import "./shareStyles.scss";
import {
    EmailIcon,
    FacebookIcon,
    FacebookMessengerIcon,
    FacebookMessengerShareButton,
    FacebookShareButton,
    LinkedinIcon,
    LinkedinShareButton,
    TelegramIcon,
    WhatsappIcon,
    XIcon,
} from "react-share";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShareNodes } from "@fortawesome/free-solid-svg-icons";
import useTranslationCustom from '../../../i18n/customHook/useTranslation';


const ShareBranchLink = ({ shortLink }) => {

    const { T } = useTranslationCustom();

    const SHARE_PREFIX = T('Packages_Detail:Text_With_Shared_Link');
    const SHARE_SUFFIX = 'Genius®';
    const EMAIL_SUBJECT = T('Packages_Detail:Email_Subject_Text');
    const fullShareText = `${SHARE_PREFIX}\n\n${shortLink}\n${SHARE_SUFFIX}`;

    const handleNativeShare = async () => {
        try {
            // `title` maps to the email subject (Intent.EXTRA_SUBJECT) on Android.
            // Without it Gmail uses the first line of the body as the subject.
            await navigator.share({ title: EMAIL_SUBJECT, text: fullShareText });
        } catch (error) {
            console.log('Error sharing:', error);
        }
    };

    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(fullShareText)}`;
    const twitterUrl  = `https://twitter.com/intent/tweet?text=${encodeURIComponent(fullShareText)}`;
    const emailUrl    = `mailto:?subject=${encodeURIComponent(EMAIL_SUBJECT)}&body=${encodeURIComponent(fullShareText)}`;

    const openTelegram = () => {
        const telegramUrl = `https://telegram.me/share/url?url=${encodeURIComponent(shortLink)}&text=${encodeURIComponent(fullShareText)}`;
        window.open(telegramUrl, 'telegram-share', 'width=550,height=450,resizable=yes');
    };

    const isMobile = /Android|iPhone|iPad|iPod|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < 768;

    if (navigator.share && isMobile) {
        return (
            <div className="Demo__container">
                <div className="Demo__some-network">
                    <button
                        onClick={handleNativeShare}
                        className="Demo__some-network__share-button native-share-button"
                        aria-label="Share"
                    >
                        <FontAwesomeIcon icon={faShareNodes} size="2x" />
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="Demo__container">
            <div className="Demo__some-network">
                <FacebookShareButton
                    url={shortLink}
                    className="Demo__some-network__share-button"
                >
                    <FacebookIcon size={32} round />
                </FacebookShareButton>
            </div>

            <div className="Demo__some-network">
                <FacebookMessengerShareButton
                    url={shortLink}
                    appId="521270401588372"
                    className="Demo__some-network__share-button"
                >
                    <FacebookMessengerIcon size={32} round />
                </FacebookMessengerShareButton>
            </div>

            {/* Direct link — full control over tweet text including Genius suffix */}
            <div className="Demo__some-network">
                <a href={twitterUrl} target="_blank" rel="noopener noreferrer"
                    className="Demo__some-network__share-button">
                    <XIcon size={32} round />
                </a>
            </div>

            <div className="Demo__some-network">
                <button onClick={openTelegram}
                    className="Demo__some-network__share-button native-share-button">
                    <TelegramIcon size={32} round />
                </button>
            </div>

            {/* Direct link — full formatted message in wa.me text param */}
            <div className="Demo__some-network">
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer"
                    className="Demo__some-network__share-button">
                    <WhatsappIcon size={32} round />
                </a>
            </div>

            <div className="Demo__some-network">
                <LinkedinShareButton
                    url={shortLink}
                    className="Demo__some-network__share-button"
                >
                    <LinkedinIcon size={32} round />
                </LinkedinShareButton>
            </div>

            {/* Direct mailto — encodeURIComponent converts \n to %0A which email clients respect */}
            <div className="Demo__some-network">
                <a href={emailUrl} className="Demo__some-network__share-button">
                    <EmailIcon size={32} round />
                </a>
            </div>
        </div>
    );
};

ShareBranchLink.propTypes = {
    shortLink: PropTypes.string,
};

export default ShareBranchLink;
